'use strict';exports.__esModule = true;exports.loadPins = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _constants = require('../../constants');
var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var requestUrls = {
  homes: '/properties/mixed_search',
  commercial: '/properties/mixed_search',
  projects: '/projects/search' };


var loadPins = (0, _reduxAct.createAction)('/LOAD_PINS');
var loadPinsSuccess = (0, _reduxAct.createAction)('/LOAD_PINS_SUCCESS');
var loadPinsFail = (0, _reduxAct.createAction)('/LOAD_PINS_FAIL');

var fetchLoad = function fetchLoad(_ref) {var params = _ref.params,type = _ref.type;
  var option = params.option === _constants.optionTypes.rent ?
  _constants.optionTypes.rent + ',' + _constants.optionTypes['rent-short'] :
  params.option;

  var data = Object.assign({}, params, { option: option });
  var formattedData = type === 'projects' ? (0, _omit2.default)(data, ['street', 'is_mobile']) : data;
  var requestConfig = data.drawn ?
  { method: 'post', data: (0, _omit2.default)(data, ['is_mobile']) } :
  { method: 'get', params: formattedData };


  return _axios2.default.request(Object.assign({ url: requestUrls[type] }, requestConfig)).
  then(loadPinsSuccess, loadPinsFail);
};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchLoad, action));};

var getPolygonName = function getPolygonName() {var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},_ref2$city = _ref2.city,city = _ref2$city === undefined ? '' : _ref2$city,_ref2$neighborhood = _ref2.neighborhood,neighborhood = _ref2$neighborhood === undefined ? '' : _ref2$neighborhood;
  if (!city && !neighborhood) {
    return null;
  }
  return (0, _slugify2.default)(city + '|' + neighborhood);
};
var handleLoadSuccess = function handleLoadSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: action.data.data,
    cityPolygon: (0, _get2.default)(action, 'data.meta.cityPolygon', null),
    cityPolygonName: !!(0, _get2.default)(action, 'data.meta.cityPolygon') && getPolygonName(action.config.params) || '' });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Failed to get company properties for pins');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    cityPolygon: null,
    error: error });

};

var initialState = {
  loaded: false };


var propertyPins = (0, _reduxAct.createReducer)(function (on) {
  on(loadPins, handleLoad);
  on(loadPinsSuccess, handleLoadSuccess);
  on(loadPinsFail, handleLoadFail);
}, initialState);exports.


loadPins = loadPins;exports.default =


propertyPins;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/propertyPins.js
// module id = 1286
// module chunks = 0